(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function(){
    var header=document.querySelector('[data-header]');
    function onScroll(){ if(window.scrollY>40) header.classList.add('scrolled'); else header.classList.remove('scrolled'); }
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
    var open=document.querySelector('[data-menu-open]'),close=document.querySelector('[data-menu-close]'),menu=document.querySelector('[data-mobile-menu]');
    if(open&&menu) open.addEventListener('click',function(){menu.classList.add('open');document.body.style.overflow='hidden';});
    function shut(){if(menu){menu.classList.remove('open');document.body.style.overflow='';}}
    if(close) close.addEventListener('click',shut);
    if(menu) menu.addEventListener('click',function(e){if(e.target===menu)shut();});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.querySelector('[data-pdp]'); if(!root) return;
    var addUrl=root.getAttribute('data-add-url');
    var sel=root.querySelector('#pdpVariantId');
    var add=root.querySelector('[data-add]');
    var qty=root.querySelector('[data-qty]');
    var pc=root.querySelector('[data-price-current]');
    var spc=root.querySelector('[data-sticky-price]');

    /* ---- galeri slider ---- */
    (function(){
      var stage=root.querySelector('.pdp__stage');
      var track=root.querySelector('[data-track]');
      if(!stage||!track)return;
      var cells=track.querySelectorAll('.pdp__cell');
      var thumbs=root.querySelectorAll('.pdp__thumb');
      var now=root.querySelector('[data-gnow]');
      var gprev=root.querySelector('[data-prev]'),gnext=root.querySelector('[data-next]');
      var n=cells.length,gi=0;
      if(n<2){ if(gprev)gprev.remove(); if(gnext)gnext.remove(); return; }

      function place(px){
        track.style.transform='translate3d(calc('+(-gi*100)+'% + '+(px||0)+'px),0,0)';
      }
      function go(k){
        gi=Math.max(0,Math.min(n-1,k));
        place(0);
        thumbs.forEach(function(t,j){
          var on=j===gi;
          t.classList.toggle('is-active',on);
          if(on){t.setAttribute('aria-current','true');}else{t.removeAttribute('aria-current');}
          if(on&&t.scrollIntoView)t.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});
        });
        if(now)now.textContent=gi+1;
        if(gprev)gprev.disabled=gi===0;
        if(gnext)gnext.disabled=gi===n-1;
      }

      thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k);});});
      if(gprev)gprev.addEventListener('click',function(){go(gi-1);});
      if(gnext)gnext.addEventListener('click',function(){go(gi+1);});

      /* klavye */
      stage.setAttribute('tabindex','0');
      stage.addEventListener('keydown',function(e){
        if(e.key==='ArrowLeft'){e.preventDefault();go(gi-1);}
        else if(e.key==='ArrowRight'){e.preventDefault();go(gi+1);}
      });

      /* dokunmatik / fare ile kaydırma */
      var sx=0,sy=0,dx=0,drag=false,lock=null,w=0;
      stage.addEventListener('pointerdown',function(e){
        if(e.pointerType==='mouse'&&e.button!==0)return;
        drag=true;lock=null;dx=0;sx=e.clientX;sy=e.clientY;w=stage.clientWidth||1;
        track.classList.add('is-drag');
      });
      stage.addEventListener('pointermove',function(e){
        if(!drag)return;
        var mx=e.clientX-sx,my=e.clientY-sy;
        if(lock===null){
          if(Math.abs(mx)<6&&Math.abs(my)<6)return;
          lock=Math.abs(mx)>Math.abs(my)?'x':'y';
          if(lock==='x'&&stage.setPointerCapture)stage.setPointerCapture(e.pointerId);
        }
        if(lock!=='x'){return;}
        dx=mx;
        /* uçlarda direnç */
        if((gi===0&&dx>0)||(gi===n-1&&dx<0))dx*=.32;
        place(dx);
      });
      function endDrag(){
        if(!drag)return;
        drag=false;track.classList.remove('is-drag');
        if(lock==='x'){
          var t=Math.min(90,w*.16);
          if(dx<-t)go(gi+1); else if(dx>t)go(gi-1); else go(gi);
        }
        dx=0;lock=null;
      }
      stage.addEventListener('pointerup',endDrag);
      stage.addEventListener('pointercancel',endDrag);
      stage.addEventListener('pointerleave',endDrag);

      /* ekran döndürünce/yeniden boyutlanınca hizayı koru */
      addEventListener('resize',function(){place(0);},{passive:true});

      go(0);
    })();

    /* adet */
    var dec=root.querySelector('[data-q="-"]'),inc=root.querySelector('[data-q="+"]');
    if(inc)inc.addEventListener('click',function(){qty.value=parseInt(qty.value||1,10)+1;});
    if(dec)dec.addEventListener('click',function(){qty.value=Math.max(1,parseInt(qty.value||1,10)-1);});

    /* varyant senkron */
    function sync(){
      var chosen=[];
      root.querySelectorAll('.pdp__opt').forEach(function(opt){var r=opt.querySelector('input:checked');if(r){chosen.push(r.value);var b=opt.querySelector('[data-opt-val]');if(b)b.textContent=r.value;}});
      root.querySelectorAll('.pdp__swbtn').forEach(function(s){var r=s.querySelector('input');s.classList.toggle('on',r&&r.checked);});
      if(!chosen.length||!sel) return;
      var match=null;
      Array.prototype.forEach.call(sel.options,function(o){var ok=true;chosen.forEach(function(v,i){if(o.getAttribute('data-opt'+(i+1))!==v)ok=false;});if(ok)match=o;});
      if(match){sel.value=match.value;
        var price=match.getAttribute('data-price');
        if(pc)pc.textContent=price; if(spc)spc.textContent=price;
        var avail=match.getAttribute('data-available')==='true';
        [add,root.querySelector('[data-buynow]'),root.querySelector('[data-sticky-add]')].forEach(function(b){if(b)b.disabled=!avail;});
      }
    }
    root.querySelectorAll('[data-opt]').forEach(function(r){r.addEventListener('change',sync);});

    /* Hemen Satın Al → ekle + ödemeye git */
    var bn=root.querySelector('[data-buynow]');
    if(bn)bn.addEventListener('click',function(){
      if(bn.disabled)return; bn.classList.add('is-loading');
      var body=new URLSearchParams();body.append('id',sel.value);body.append('quantity',qty.value||1);
      fetch(addUrl,{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/x-www-form-urlencoded'},body:body.toString()})
        .then(function(r){return r.json();}).then(function(){window.location.href='/checkout';})
        .catch(function(){bn.classList.remove('is-loading');});
    });

    /* mobil sticky "Sepete ekle" → ana formu gönder */
    var sa=root.querySelector('[data-sticky-add]');
    if(sa&&add)sa.addEventListener('click',function(){if(!sa.disabled)add.click();});

    /* teslim tahmini */
    var dv=root.querySelector('[data-deliver]');
    if(dv){
      var mo=['Oca','Şub','Mar','Nis','May','Haz','Tem','Ağu','Eyl','Eki','Kas','Ara'];
      var dmin=parseInt(root.getAttribute('data-dmin'),10)||1,dmax=parseInt(root.getAttribute('data-dmax'),10)||3;
      var n=new Date(),a=new Date(n),b=new Date(n);a.setDate(n.getDate()+dmin);b.setDate(n.getDate()+dmax);
      dv.textContent=a.getDate()+' '+mo[a.getMonth()]+' – '+b.getDate()+' '+mo[b.getMonth()];
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
